/* eslint sort-imports-es6-autofix/sort-imports-es6: 0 */
import 'client/css/signup.css';
import 'client/signup/utilities/validationRules';

import ConfigService from 'client/util/ConfigService';
import DataDog from 'client/util/monitoring/DataDog';
import EventManager from 'client/GrowthEngineering/EventManager';
import { EventsPlugin, setupEventTracking } from '@jumpcloud/ui-events-vue';
import Router from 'client/signup/routes/Router';
import SignupApi from 'client/signup/api/SignupApi';
import TestIdMixin from 'client/signup/mixins/TestIdMixin';
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './signup/store/signupStore';

(async () => {
  try {
    // Ensure awating config service does not hang forever
    const configServiceTimeout = setTimeout(() => { throw new Error('request timeout'); }, 5000);
    await ConfigService.initialize();
    window.clearTimeout(configServiceTimeout);

    DataDog.initialize({ serviceName: 'signup' });

    // determine visitor ID
    const visitorId = store.getters.getVisitorId;
    store.dispatch('updateVisitorId', visitorId);

    await store.dispatch('ExperimentsModule/initializeExperiments');

    if (ConfigService.disableAnalytics) {
      window.analytics = undefined;
    } else {
      // determine segmentUuid
      const segmentUuid = store.getters.getSegmentUuid;
      if (segmentUuid) store.dispatch('updateSegmentUuid', segmentUuid);

      setupEventTracking({
        writeKey: ConfigService.segmentScriptWriteKey,
      });
    }

    EventManager.initialize();
  } catch (e) {
  // eslint-disable-next-line  no-console
    console.error(`Error initializing Growth libraries: ${e.toString()}`);
  }
  SignupApi.initialize();
  // Integrate global Vue packages
  Vue.use(VueRouter);
  Vue.use(EventsPlugin);
  Vue.mixin(TestIdMixin);
  new Vue({
    name: 'SignupApp',
    store,
    template: '<router-view/>',
    router: Router,
  }).$mount('.signup-container');
})();
